import React, { useEffect, useState } from 'react';
import Shimmer_graph from '../../components/shimmer_graph';

function StopLocation({ value }) {
  const [graphUrl, setGraphUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      setGraphUrl(value.graph_url);
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  useEffect(() => {
    if (graphUrl?.toLowerCase().includes('no data')) {
      setLoading(false);
    }
  }, [graphUrl]);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const isNoDataAvailable = graphUrl?.toLowerCase().includes('no data');

  return (
    <div style={{ width: '100%', height: '800px', position: 'relative' }}>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
            backgroundColor: "white",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Shimmer_graph />
        </div>
      )}

      {isNoDataAvailable ? (
        <p style={{ textAlign: 'center', marginTop: '50px', fontSize: '18px', color: 'black' }}>
          No data available to display the graph.
        </p>
      ) : graphUrl ? (
        <iframe
          src={graphUrl}
          width="100%"
          height="900px"
          style={{ width: '100%', height: '900px', border: 'none' }}
          title="Graph Display"
          onLoad={handleIframeLoad}
        />
      ) : (
        <p>Loading graph...</p>
      )}
    </div>
  );
}

export default StopLocation;
